import * as moment from 'moment';
import { hasDate } from '@app/shared/comparison-helpers.service';
import { Moment } from 'moment';

const Iso8601RegEx = /^(\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}(:\d{2}(\.\d{1,8})?)?(Z|((-|\+)\d{1,2}:\d{1,2}))?)?)$/;

export const ISO_STRING_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const ISO_STRING_FORMAT_MIDNIGHT_TIME = 'YYYY-MM-DDT00:00:00';
export const ISO_STRING_FORMAT_NO_TIME = 'YYYY-MM-DD';

export const convertIso8601ToDate = (date: any): Moment => {
  switch (date?.constructor?.name) {
    case 'Date':
      return moment(date);
    case 'Moment':
      return moment(date);
    case 'String':
      const a = Iso8601RegEx.exec(date);
      if (a && a.length && a.length > 0) {
        return moment(a[0]);
      } else {
        return undefined;
      }
    default:
      if (moment.isMoment(date)) {
        return moment(date);
      } else {
        return undefined;
      }
  }
};

export const convertDateToIsoString = (object: Object) => {
  const dateProperties = {};

  Object.getOwnPropertyNames(Object.getPrototypeOf(object))
    .concat(Object.getOwnPropertyNames(object))
    .map((property: any) => {
      if (hasDate(object[property])) {
        dateProperties[property] = moment(object[property]).format('YYYY-MM-DDTHH:mm:ss');
      } else {
        dateProperties[property] = object[property];
      }
    });
  return Object.assign({}, object, dateProperties);
};

export const convertMinToTimeString = (minutes: number): string => {
  const hour = Math.floor(minutes / 60)
    .toString()
    .padStart(2, '0');
  const minute = (minutes % 60).toString().padStart(2, '0');

  return `${hour}:${minute}`;
};

export const isSQLNullDate = (dateInput: string | Date | Moment): boolean => {
  const typedDate = convertIso8601ToDate(dateInput);
  if (typedDate) {
    if (typedDate.get('year') === 1899) {
      return true;
    } else {
      return false;
    }
  }

  return undefined;
};

/*
The idea here was to be able to decorate a property on a class of a Moment (Date) type
and have the getter and setter auto-generated. The problem is that the `_value` object in
the method was being shared between all instances of a class. It would be great if we
could get this working, and that is why it remains. Maybe one day...

export function ApiDateProperty(): PropertyDecorator {
  return function (target: Object, key: string | symbol) {
    let _value = target[key];

    const getter = () => {
      return _value;
    };

    const setter = (val) => {
      _value = convertIso8601ToDate(val);
    };

    Reflect.deleteProperty(target, key);
    Reflect.defineProperty(target, key, {
      get: getter,
      set: setter
    });
  };
}
*/
